import Side2PlaceHolder from 'assets/images/side2_placeholder1.gif';
import PlaceHolderStripes from 'assets/images/placeholder_stripes.gif';

export default class TableElement {
  constructor(options) {
    this.options = options;

    this.learnEditor = options.editor ? options.editor : null;

    this.editor_enabled = false;
    this.saved_text = '';

    this.templates = {
      "table_modal": "<div class='modal' id='table-modal'>" +
        "<div class='modal-dialog'>" +
          "<div class='modal-content'>" +
            "<div class='modal-header'>" +
              "<a href='#' class='close table-modal-close'>×</a>" +
              "<h5>Add Table Row</h5>" +
            "</div>" +
            "<div class='modal-body'></div>" +
            "<div class='modal-footer'>" +
              "<a href='#' class='delete-editor-table admin-button gray' tabindex='-1'>DELETE</a>" +
              "<a href='#' class='table-modal-close admin-button gray' data-target='#table-modal' tabindex='-1'>CANCEL</a>" +
              "<a href='#' class='save-editor-table admin-button gray'>SAVE</a>" +
            "</div>" +
          "</div>" +
        "</div>" +
      "</div>",
      "table_editor": "<div class='table-element-container build-table-container'>" +
                      "</div>",
      "table_editor_cell": "<div class='editor-table-cell'>" +
                             "<div class='editor-table-cell-header'>" +
                               '<div class="editor-table-cell-header-text">' +
                                 'Text' +
                               '</div>' +
                               '<div class="editor-table-cell-header-image">' +
                                 'Image' +
                               '</div>' +
                               '<div class="clear"></div>' +
                             "</div>" +
                             "<div class='editor-table-cell-body'>" +
                               "<div class='editor-table-cell-text-editor'>" +
                               "</div>" +
                               "<div class='editor-table-cell-image-editor' style='display:none;'>" +
                                    "<div class='fileinput-button editor-table-image-placeholder'>" +
                                      "<span>" +
                                        `<img class='medium-placeholder img-responsive' src='${Side2PlaceHolder}' alt=''>` +
                                        "<input class='button add-table-image' type='file' name='files'>" +
                                      "</span>" +
                                      '<div class="clear"></div>' +
                                    "</div>" +
                                    '<div class="clear"></div>' +
                               "</div>" +
                             "</div>" +
                             "<div class='editor-table-cell-footer'>" +
                               "<a href='#' class='editor-table-remove-column' tabindex='-1'>Remove Column</a>" +
                             "</div>" +
                           "</div>",
      "table_editor_add_cell": "<div class='editor-table-add-cell'>" +
                                 "<a href='#' class='editor-table-add-column'><i class='fa fa-plus'></i></a>" +
                               "</div>",
      "empty_table":  "<div class='table-element-container table-element build-table-container'>" +
                        "<table class='editor-table'>" +
                        "</table>" +
                      "</div>",
      "empty_cell": "<td></td>",
      "empty_header": "<th></th>",
      "empty_row": "<tr></tr>",
      "add_row": "<a class='editor-table-add-row' href=''><i class='fa fa-plus-circle fa-white'></i></a>",
      "add_column": "<a class='editor-table-add-column' href=''><i class='fa fa-plus-circle fa-white'></i></a>",
      "delete_table": "<a class='editor-table-delete-table' href=''><i class='fa fa-trash-o fa-white'></i></a>",
      "cell_options": "<div class='editor-table-cell-options'>" +
                        "<span class='editor-table-add-text'><i class='fa fa-pencil'></i></span>" +
                      "</div>",
      "remove_row": "<a href='' class='remove-row-link editor-table-outer-links'><i class='fa fa-times-circle fa-white'></i></a>",
      "remove_column": "<a href='' class='remove-column-link editor-table-outer-links'><i class='fa fa-times-circle fa-white'></i></a>",
      "row_header": "<a href='' class='toggle-row-header-link editor-table-outer-links'><i class='fa fa-star-o fa-white'></i></a>",
      "column_header": "<a href='' class='toggle-column-header-link editor-table-outer-links'><i class='fa fa-star-o fa-white'></i></a>",
      "text_editor": "<div class='text-editor'>" +
                        "<textarea id='editor'></textarea>" +
                        "<button class='btn save-editor'>Save</button>" +
                        "<button class='btn cancel-editor'>Cancel</button>" +
                        "<span class='btn fileinput-button table-button'>" +
                            "<i class='fa fa-picture-o fa-white'></i>" +
                            "<span> Image</span>" +
                            "<input id='add-table-image' type='file' name='files'>" +
                        "</span>" +
                     "</div>",
      "image_modifiers": "<span class='editor-table-build-image'>" +
          "<span class='fileinput-button replace-button'>replace<input class='editor-table-replace-build-image' type='file' name='files'></span>" +
          "<a href='#'' class='editor-table-delete-build-image'>delete</a>" +
          "<a href='#' class='editor-table-license-build-image'>update license</a>" +
          "<div class='clear'</div>" +
          "</span>",
      'image_placeholder': `<img src="${PlaceHolderStripes}" class="image-uploading img-responsive" />`
    }

    this.init();
  }

  init() {
    var that = this;

    $(document).on('click', '.build-table-container > table tr', $.proxy(this.edit_existing_row, this));
    $(document).on('click', '.add-build-table-container', $.proxy(this.display_table_overlay, this));
    $(document).on('click', '.table-modal-close', $.proxy(this.close_table_overlay, this));
    $(document).on('click', '.save-editor-table', $.proxy(this.save_table, this));
    $(document).on('click', '.delete-editor-table', $.proxy(this.delete_row, this));

    //editor functionality
    $(document).on('click', '.editor-table-remove-column', $.proxy(this.remove_column, this));
    $(document).on('click', '.editor-table-add-column', $.proxy(this.add_column, this));

    $(document).on('click', '.editor-table-cell-header-text', this.show_text_editor);
    $(document).on('click', '.editor-table-cell-header-image', this.show_image_editor);

    $(document).on('click', '.editor-table-license-build-image', $.proxy(this.update_image_license, this));
  }

  shouldShowButton() {
    return $('input[name="page_type"]').val() !== 'user';
  }

  addButtonTemplate() {
    return '<a class="add-build-table-container" href="#"><i class="fa fa-table"></i>Table</a>';
  }

  display_table_overlay(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    var $table_modal = $(this.templates.table_modal);
    var $element = $(event.currentTarget).closest('.button-bar, .bottom-button-bar');
    $element.replaceWith($table_modal);
    var $editor_container = $(this.templates.table_editor);

    //open up with the default of 3 columns, but if we are appending to an existing table, match the number of columns to that table.
    var column_count = 3;
    if ($table_modal.prev('.build-table-container').length) {
      column_count = 0;
      $table_modal.prev('.build-table-container').find('tr:nth-child(1) td, tr:nth-child(1) th').each(function () {
        if ($(event.currentTarget).attr('colspan')) {
          column_count += +$(event.currentTarget).attr('colspan');
        } else {
           column_count++;
        }
      });
    }

    for(var i=0; i<column_count; i++) {
      var $table_editor_cell = $(this.templates.table_editor_cell);
      $('.editor-table-cell-header-text', $table_editor_cell).addClass('active');
      $('.editor-table-cell-text-editor', $table_editor_cell).addClass('active').html("<textarea class='editor-table-cell-textarea' tabindex='" + (i+1) + "' id='column-" + i + "' /></div>");
      $editor_container.append($table_editor_cell);
    }

    $editor_container.append(this.templates.table_editor_add_cell);

    $('.modal-body', $table_modal).append($editor_container);

    this.learnEditor.enable_text_editor($('.editor-table-cell-textarea'));

    var total_existing_columns = $('.editor-table-cell').length;
    var new_container_width = ((total_existing_columns) * 230) + 36;
    $editor_container.css('width', new_container_width + 'px');

    $('#table-modal').modal({
      backdrop: 'static'
    });

    this.learnEditor.prepend_table_image_modifiers();
    this.image_upload_init();
  }

  close_table_overlay(event) {
    event.preventDefault();

    var $table_modal = $('#table-modal');

    this.learnEditor.disable_text_editor($('.editor-table-cell-textarea'));
    $table_modal.modal('hide');

    $('.editor-table-build-image').remove();

    if ($table_modal.hasClass('edit-existing-row')) {
      var existing_content = $table_modal.data('content');
      $table_modal.replaceWith(existing_content);
    } else {
      $table_modal.remove();
    }

    this.learnEditor.finishEditing();
  }

  save_table(event) {
    event.preventDefault();

    var parsed_column_data = [];

    tinymce.triggerSave();

    var $content_columns = $('.editor-table-cell > .editor-table-cell-body > .active');

    $content_columns.each(function(index, content) {
      if ($(content).hasClass('editor-table-cell-text-editor')) {
        var id = $('textarea', content).attr('id');
        var text_content = tinymce.get(id).getContent();

        if ($(content).hasClass('header')) {
          parsed_column_data.push("<th>" + text_content + "</th>");
        } else {
          parsed_column_data.push("<td>" + text_content + "</td>");
        }

      } else {
        $(content).find('.editor-table-build-image').remove();

        var asset_class = $(content).find('img').attr('class').replace('img-responsive' , '');
        var $td = $('<td></td>');

        $td.addClass(asset_class);
        $td.addClass('image-cell');
        $td.append($(content).html());

        //get outerHTML
        var image_content = $td.clone().wrap('<div />').parent().html();
        parsed_column_data.push(image_content);
        //gather image information
      }
    });

    var $row = $('<tr></tr>');

    for (var i=0; i<parsed_column_data.length; i++) {
      $row.append(parsed_column_data[i]);
    }

    this.learnEditor.disable_text_editor($('.editor-table-cell-textarea'));
    $('#table-modal').modal('hide');
    //$('#table-modal').replaceWith($row);

    var $previous_element = $('#table-modal').prev();
    var $parent_table_element = $('#table-modal').closest('.build-table-container');
    if ($parent_table_element.length) {
      $('#table-modal').replaceWith($row);
    } else if ($('#table-modal').prev().hasClass('build-table-container')) {
      $previous_element.find('table > tbody').append($row);
      $('#table-modal').remove();
    } else {
      var $new_table_container = $(this.templates.empty_table);
      $('table', $new_table_container).append($row);
      $('#table-modal').replaceWith($new_table_container);
    }

    this.learnEditor.save_page("Before Save Table Row");
  }

  edit_existing_row(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    var $table_modal = $(this.templates.table_modal);
    $(event.currentTarget).replaceWith($table_modal);
    var $editor_container = $(this.templates.table_editor);

    $table_modal.addClass('edit-existing-row').data('content', $(event.currentTarget));

    var that = this;
    $('td, th', event.currentTarget).each(function(index, td) {
      var $table_editor_cell = $(that.templates.table_editor_cell);

      if ($(td).hasClass('image-cell')) {
        $('.editor-table-cell-header-image', $table_editor_cell).addClass('active');
        $('.editor-table-cell-text-editor', $table_editor_cell).hide();
        $('.editor-table-cell-image-editor', $table_editor_cell).addClass('active').html($(td).html()).show();
        $('.editor-table-cell-text-editor', $table_editor_cell).html("<textarea class='editor-table-cell-textarea' tabindex='" + (index+1) + "' id='column-" + index + "' ></textarea></div>");
      } else {
        if ($(td).is('th')) {
          $('.editor-table-cell-text-editor',$table_editor_cell).addClass('header');
        }

        $('.editor-table-cell-header-text', $table_editor_cell).addClass('active');
        $('.editor-table-cell-text-editor', $table_editor_cell).addClass('active').html("<textarea class='editor-table-cell-textarea' tabindex='" + (index+1) + "' id='column-" + index + "' >" + $(td).html() + "</textarea></div>");
      }
      $editor_container.append($table_editor_cell);
    });

    $editor_container.append(this.templates.table_editor_add_cell);

    $('.modal-body', $table_modal).append($editor_container);

    this.learnEditor.enable_text_editor($('.editor-table-cell-textarea'));

    var total_existing_columns = $('.editor-table-cell').length;
    var new_container_width = ((total_existing_columns) * 230) + 36;
    $editor_container.css('width', new_container_width + 'px');

    $('#table-modal').modal({
      backdrop: 'static'
    });

    this.learnEditor.prepend_table_image_modifiers();
    this.image_upload_init();
  }

  delete_row(event) {
    event.preventDefault();

    this.learnEditor.disable_text_editor($('.editor-table-cell-textarea'));
    $('#table-modal').modal('hide');
    $('#table-modal').remove();

    this.learnEditor.save_page("Before Delete Table Row");
  }

  update_image_license(event) {
    event.preventDefault();

    this.learnEditor.update_image_license($(event.currentTarget).parents('.table-image').find('a img'));
  }

  image_upload_init() {
    var that = this;
    //console.log("image_upload_init");
    var upload_url = '/pages/' + $('input[name$="page_id"]').val() + '/assets/table';
    //actual upload of image, handled by jquery-fileupload plugin

    $('.add-table-image').each(function () {
      $(this).fileupload({
        dataType: 'html',
        progressInterval: 20,
        bitrateInterval: 100,
        url: upload_url,
        add: function(e, data) {
          $(this).closest('.editor-table-cell-image-editor').find('.medium-placeholder, .table-image img').replaceWith(that.templates.image_placeholder);

          data.submit();
        },
        done: function (e, data) {
          that.editor_enabled = false;
          //$('.bar').css("width", 0);
          //$('.progress').addClass('fade');

          var result = $(data.result)[0];

          if ($(result).is('#cropModal')) {
            $(this).closest('.editor-table-cell-image-editor').addClass('active-image-upload-container');
            that.learnEditor.crop_image(data.result);
          } else if ($(result).is('.table-image')) {
            var $image_container = $(this).closest('.editor-table-cell-image-editor');

            var $result = $(data.result);
            $image_container.html($result);
          }
          that.learnEditor.prepend_table_image_modifiers();
          that.learnEditor.clear_publish_text();
        }
      });
    });
  }

  add_column(event) {
    event.preventDefault();

    //prepare for new column getting added
    $('.editor-table-add-cell').remove();

    var $editor_container = $('#table-modal .build-table-container');
    var container_width = $editor_container.width();

    //each column cell is zero indexed for the id
    var total_existing_columns = $('.editor-table-cell').length;
    var $table_editor_cell = $(this.templates.table_editor_cell);
    $('.editor-table-cell-header-text', $table_editor_cell).addClass('active');
    $('.editor-table-cell-text-editor', $table_editor_cell).addClass('active').html("<textarea class='editor-table-cell-textarea' tabindex='" + (total_existing_columns+1) + "' id='column-" + total_existing_columns + "' />");

    var new_container_width = ((total_existing_columns+1) * 230) + 36;
    $editor_container.css('width', new_container_width + 'px');

    $editor_container.append($table_editor_cell);
    $editor_container.append(this.templates.table_editor_add_cell);

    this.learnEditor.enable_text_editor($('.editor-table-cell-textarea'));

    $('.modal-body').animate({scrollLeft: new_container_width}, 300);

    this.image_upload_init();
  }

  remove_column(event) {
    event.preventDefault();

    var $textarea = $(event.currentTarget).parents('.editor-table-cell').find('textarea');

    this.learnEditor.disable_text_editor($textarea);

    $(event.currentTarget).parents('.editor-table-cell').remove();

    var $editor_container = $('#table-modal .build-table-container');
    var total_existing_columns = $('.editor-table-cell').length;
    var new_container_width = ((total_existing_columns) * 230) + 36;
    $editor_container.css('width', new_container_width + 'px');
  }

  show_text_editor(event) {
    event.preventDefault();

    var $editor_body_container = $(this).closest('.editor-table-cell').find('.editor-table-cell-body');

    $(this).addClass('active');

    $(this).next().removeClass('active');
    $editor_body_container.find('.editor-table-cell-image-editor').removeClass('active').hide();
    $editor_body_container.find('.editor-table-cell-text-editor').addClass('active').show();
  }

  show_image_editor(event) {
    event.preventDefault();

    var $editor_body_container = $(this).closest('.editor-table-cell').find('.editor-table-cell-body');

    $(this).addClass('active');
    $(this).prev().removeClass('active');
    $editor_body_container.find('.editor-table-cell-text-editor').removeClass('active').hide();
    $editor_body_container.find('.editor-table-cell-image-editor').addClass('active').show();
  }
}
